/**
 * Funzione che rimuove gli spazi multipli ad una stringa
 */
const removeMultipleSpace = (value) => (value ? value.trim().replace(/^\s+/, '').replace(/\s\s+/g, ' ') : value);
/**
 * Funzione che maiuscolizza le parole passate per visualizzarle come nomi ('paOLO roSSI' -> 'Paolo Rossi')
 * e rimuove spazi iniziali e finali
 */
const namecase = (value) => {
    if (!value)
        return value;
    let endWithSpace = false; // lascio uno spazio in modo da poter scrivere più parole
    if (value.endsWith(' ')) {
        endWithSpace = true;
    }
    let updatedValue = value.trim();
    updatedValue = updatedValue.toLowerCase();
    updatedValue = updatedValue.replace(/[ '-/(]([a-z])/g, (x) => x.toUpperCase());
    updatedValue = updatedValue.replace(/^([a-z])/g, (x) => x.toUpperCase());
    if (endWithSpace) {
        return `${updatedValue} `;
    }
    return updatedValue;
};

export { namecase, removeMultipleSpace };
